export default __webpack_public_path__ + "static/media/seat01.30b7274c.png";